import {
  TextInput as MantineTextInput,
  type TextInputProps as MantineTextInputProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type TextInputProps = CoreComponentProps<MantineTextInputProps, 'input'>;

export function TextInput({ testId, view = "all", ...rest }: TextInputProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineTextInput data-testid={testId} {...rest} />;
}
